export enum EReferralSourceOperator {
  IS_EXACTLY = 'is_exactly',
  CONTAINS = 'contains',
}
export interface IFilterReferralSource {
  operator?: EReferralSourceOperator;
  value?: string;
}
